import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectIsInProgress } from '../../spinner/ducks';
import { normalizeString } from '../../../common/utils/helpers';
import { EmailLogsList } from '../components';
import { apiCallIds } from '../api';
import {
  fetchEmailLogsActions,
  selectEmailLogs,
  selectEmailLogsFilter,
  selectEmailLogsPagination,
  setEmailLogsFilterAction
} from '../ducks';
import Spin from 'antd/lib/spin';

const mapStateToProps = state => ({
  emailLogs: selectEmailLogs(state),
  filter: selectEmailLogsFilter(state),
  isLoading: selectIsInProgress(state, apiCallIds.FETCH_EMAIL_LOGS),
  pagination: selectEmailLogsPagination(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchEmailLogs: fetchEmailLogsActions.request,
      setFilter: setEmailLogsFilterAction,
    },
    dispatch
  ),
});

const defaultFilter = {
  search: '',
  sentDateStart: '',
  sentDateEnd: ''
};

@connect(mapStateToProps, mapDispatchToProps)
export default class EmailLogsListContainer extends Component {
  static propTypes = {
    actions: PropTypes.object,
  };

  componentDidMount() {
    const { actions } = this.props;
    actions.setFilter(defaultFilter);
    actions.fetchEmailLogs(defaultFilter);
  }

  handleTableChange = (pagination, filters, sorter) => {
    const { actions, filter } = this.props;
    actions.fetchEmailLogs({
      ...filter,
      pageNo: pagination.current - 1,
    });
  };

  onFilterChange = filterKey => filterValue => {
    const { actions, filter } = this.props;
    actions.setFilter({
      ...filter,
      [filterKey]: filterValue,
    });
  };


  onFilterDateRangeChange = ([dateFrom, dateTo]) => {
    const { actions, filter } = this.props;
    actions.setFilter({
      ...filter,
      sentDateStart: dateFrom ? dateFrom.startOf('day').toISOString() : "",
      sentDateEnd: dateTo ? dateTo.endOf('day').toISOString() : ""
    })
  };

  onFilterSearchChange = filterValue => {
    const { actions, filter } = this.props;
    actions.setFilter({
      ...filter,
      search: normalizeString(filterValue)
    });
  };

  onFilterStatusChange = this.onFilterChange('status');
  render() {
    const { emailLogs, filter, isLoading, pagination } = this.props;

    return (<div>
      {!emailLogs ?
        <Spin className="dasboard-spinner" spinning={!emailLogs}>
          <div className="dashboard-spinner-message">{"Prebieha výpočet dát pre dashboard"}</div>
        </Spin> :

        <EmailLogsList
          emailLogs={emailLogs}
          filter={filter}
          isLoading={isLoading}
          onFilterSearchChange={this.onFilterSearchChange}
          onFilterDateRangeChange={this.onFilterDateRangeChange}
          onFilterStatusChange={this.onFilterStatusChange}
          onTableChange={this.handleTableChange}
          pagination={pagination}
        />}
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/messaging-dashboard/containers/EmailLogsListContainer.js